<template>
  <div class="navigation">
    <div class="container nav-bar">
      <div class="row">
        <div class="col-4 col-sm-3 no-padding my-rux-left">
          <BurgerMenu />
          <div v-if="isLoggedIn" style="width: 100%">
            <div class="d-flex d-md-none">
              <div @click="toggleSearch" class="material-symbols-outlined pointer">
                search
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 col-sm-6 no-padding">
          <router-link to="/List">
            <img
              class="logo"
              src="../assets/rux-logo.png"
            />
          </router-link>
        </div>
        <div v-if="isLoggedIn" class="col-4 col-sm-3 no-padding my-rux-right">
          <div class="text" @click="toggleRuxList">
            My RUX ({{ getRuxListLength }})
            <i
              v-if="!showRuxList && getRuxListLength > 0"
              class="material-symbols-outlined"
              >expand_more</i
            >
            <i v-if="showRuxList" class="material-symbols-outlined">expand_less</i>
          </div>
          <div class="d-none d-md-flex">
            <div
              @click="toggleSearch"
              :class="{ 'fix-top': getRuxListLength === 0 }"
              class="material-symbols-outlined pointer right-menu"
            >
              search
            </div>
          </div>
          <div
            @click="logout"
            class="material-symbols-outlined right-menu pointer"
            :class="{ 'fix-top': getRuxListLength === 0 }"
            src="./../assets/log_out.svg"
            title="Log Out Of RUX"
          >
          logout
        </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9">
        <NavigationRuxList
          v-if="showRuxList"
          :items="ruxList"
          :showAll="true"
          :handleClick="hideList"
          :showImage="true"
          class="navList"
        />
      </div>
    </div>
    <div class="container d-block">
      <Search :handleClick="hideList" v-if="showSearchBar" class="search" />
    </div>
  </div>
</template>
<script>
import NavigationRuxList from './NavigationRuxList.vue'
import Search from './Search'
import BurgerMenu from './BurgerMenu'
import { mapGetters, mapState } from 'vuex'
// Very simple navigation component
export default {
  name: 'Navigation',
  components: {
    NavigationRuxList,
    Search,
    BurgerMenu,
  },
  data: () => {
    return {
      showRuxList: false,
    }
  },
  computed: {
    // Get the number of rux from the store
    ...mapGetters('rux', ['getRuxListLength']),
    ...mapState({
      isAuth: (state) => state.auth.isAuth,
      showSearchBar: (state) => state.rux.showSearchBar,
    }),
    isLoggedIn: function () {
      return this.isAuth
    },
    ruxList: function () {
      return this.$store.state.rux.ruxList.map((val) => {
        return {
          value: val.shortDescription,
          serialNumber: val.serialNumber,
        }
      })
    },
  },
  methods: {
    // fired when the user clicks off the menu
    hideList: function () {
      this.showRuxList = false
      this.$store.dispatch('rux/showSearchBar', false)
    },
    //Logout
    logout: function () {
      this.$store.dispatch('auth/logout')
    },
    // Show or hide the list.
    toggleRuxList: function () {
      if (this.getRuxListLength > 0) {
        this.showRuxList = !this.showRuxList
      }
    },
    toggleSearch: function () {
      this.$store.dispatch('rux/showSearchBar', !this.showSearchBar)
    },
  },
}
</script>
<style lang='scss' scoped>
div.navigation {
  background-color: black;
  z-index: 20;
  position: relative;
  box-shadow: 0px 3px 6px #00000029;
}
div.nav-bar {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: none;
  @include respond-to('sm') {
    min-height: 100px;
  }
  @include respond-to('md') {
    min-height: 140px;
  }
  .logo {
    width: 64px;
    @include respond-to('sm') {
      width: initial;
    }
  }
}
.search {
  padding-bottom: 10px;
}
div.row {
  .no-padding {
    padding-left: 0;
    padding-right: 0;
  }
  width: 100%;
  .my-rux-left, .my-rux-right {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    .text {
      border-bottom: 2px solid;
      padding: 1px;
      padding-top: 0px;
      color: $ruxBeige;
      cursor: pointer;
      font-size: 13px;
      text-transform: uppercase;
      @include respond-to('sm') {
        font-size: 13px;
      }
      .material-symbols-outlined {
        position: relative;
        color: #F7F6EF;
        top: 4px;
        font-size: 18px;
        @include respond-to('sm') {
          font-size: 24px;
          top: 7px;
        }
      }
    }
    .right-menu {
      display: none;
      @include respond-to('sm') {
        display: block;
        position: relative;
        top: 5px;
        margin-left: 4px;
        &.fix-top {
          top: 0px;
        }
      }
    }
  }
  .my-rux-right {
    justify-content: flex-end;
  }
}
.navList {
  position: absolute;
  right: 0px;
  background-color: black;
  border: 1px solid white;
  color: white;
}

</style>
